export interface IOdataField {
  toFieldString(): any;
}
